import { CircularProgress, Grid, styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

export const Wrapper = styled(Grid)(() => ({
  padding: "12px 24px",
}));
export const MainGrid = styled(Grid)(() => ({
  borderBottom: `1px solid ${colors.gray200}`,
}));

export const SubTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: colors.gray600,
}));

export const AditionalInfo = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "16px",
  letterSpacing: "0.4px",
  color: colors.gray600,
}));

export const Loading = styled(CircularProgress)(() => ({
  marginRight: "10px",
  color: colors.gray400,
}));
